import { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Layout, notification, Button } from "antd";
import MenuTop from "../components/MenuTop";
import MenuSider from "../components/MenuSider";
import useAuth from "../hooks/useAuth";
import {
  PASSWORD_WARNING_DAYS, PASSWORD_WARNING_SHOWN, USER_UUID
} from "../utils/constants";
import { getPasswordStatus } from "../utils/passwordStatus";

import "../components/styles/MainLayout.scss";

export default function MainLayout(props) {
  // const { match, routes } = props;
  const navigate = useNavigate();
  const routerLocation = useLocation();
  const { location } = props;
  const [menuCollapsed, setMenuCollapsed] = useState(false);
  const { Header, Content, Footer } = Layout;
  const { user, isLoading } = useAuth();


  // Redireccion y aviso de caducidad.
  useEffect(() => {
  if (isLoading || !user) return;

  const userUuid = localStorage.getItem(USER_UUID);
  const currentPath = routerLocation.pathname;
  const onChangePasswordPage = currentPath.startsWith('/users/changepassword');

  const { expired: isExpired, expiresInDays } = getPasswordStatus();
  if (expiresInDays === null) return;

  // 1. Bloqueo si esta caducada
  if (isExpired && !onChangePasswordPage && userUuid) {
    navigate(`/users/changepassword/${userUuid}`);
    return;
  }

  // 2. Aviso si quedan pocos dias
  const alreadyShown = sessionStorage.getItem(PASSWORD_WARNING_SHOWN) === 'true';

  if (!isExpired
      && expiresInDays > 0
      && expiresInDays <= PASSWORD_WARNING_DAYS
      && !alreadyShown
      && !onChangePasswordPage
      && userUuid) {

    const key = `pwd-warning-${Date.now()}`;
    const btn = (
      <Button
        type="primary"
        size="small"
        onClick={() => {
          notification.destroy(key);
          navigate(`/users/changepassword/${userUuid}`);
        }}
      >
        {'Cambiar ahora'}
      </Button>
    );

    notification.warning({
      key,
      message: 'Su contraseña caducará pronto',
      description: `Le quedan ${expiresInDays} día${expiresInDays === 1 ? '' : 's'} para cambiar su contraseña. Pulse el botón para hacerlo ahora.`,
      btn,
      duration: 0
    });
    sessionStorage.setItem(PASSWORD_WARNING_SHOWN, 'true');
  }
}, [user, isLoading, routerLocation.pathname, navigate]);

  useEffect(() => {
    if (!isLoading && !user) {
      navigate("/login", { replace: true });
    }
  }, [user, isLoading, navigate]);

  // si hay usuario logeado y no se está comprobando
  if (user && !isLoading) {
    return (
      <Layout>
        <MenuSider menuCollapsed={menuCollapsed} location={location} />
        <Layout
          className="layout-admin"
          style={{ marginLeft: menuCollapsed ? "80px" : "200px" }}
        >
          <Content className="layout-admin__content">
            <Outlet />
          </Content>
          <Header className="layout-admin__header" style={{zIndex: 3}} >
            <MenuTop
              menuCollapsed={menuCollapsed}
              setMenuCollapsed={setMenuCollapsed}
              homeUrl={location.path}
            />
          </Header>

          <Footer className="layout-admin__footer" style={{ textAlign: 'center' }}>
            Kiconex Server © 2018-{new Date().getFullYear()} Created by
            <a href="http://kiconex.es"> kiconex </a>
          </Footer>
        </Layout>
      </Layout >
    );
  }

  return null;
}
